import { render, staticRenderFns } from "./InstantDashboard.vue?vue&type=template&id=7841bacd&scoped=true&"
import script from "./InstantDashboard.vue?vue&type=script&lang=js&"
export * from "./InstantDashboard.vue?vue&type=script&lang=js&"
import style0 from "./InstantDashboard.vue?vue&type=style&index=0&id=7841bacd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7841bacd",
  null
  
)

export default component.exports